import { Grid, GridCell, LinkBoxProps, LinkBox, Container } from 'ui/components';

import styles from './LinkBoxList.module.scss';

export interface LinkBoxListProps {
	items: LinkBoxProps[];
	desktopWidth?: Models.GridCellWidth;
	mobileWidth?: Models.GridCellWidth;
	containerWidth?: Models.SectionWidth;
}

export const LinkBoxList: React.FC<LinkBoxListProps> = ({ items, desktopWidth = '33', mobileWidth = '100', containerWidth = 'Standard' }) => {
	return (
		<Container width={containerWidth} className={styles.LinkBoxList}>
			<Grid full wrap rowGap>
				{items?.map((item, index) => (
					<GridCell key={index} desktopWidth={desktopWidth} mobileWidth={mobileWidth}>
						<LinkBox
							heading={item.heading}
							links={item.links}
							moreElementsLink={item.moreElementsLink}
							variant={item.variant}
							backButton={item.backButton}
						/>
					</GridCell>
				))}
			</Grid>
		</Container>
	);
};
